import { render } from "./Sale_Assets.vue?vue&type=template&id=21e73e4b"
import script from "./Sale_Assets.vue?vue&type=script&lang=js"
export * from "./Sale_Assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__